import { render, staticRenderFns } from "./RadioImage.vue?vue&type=template&id=11a2a7c3&scoped=true"
import script from "./RadioImage.vue?vue&type=script&lang=js"
export * from "./RadioImage.vue?vue&type=script&lang=js"
import style0 from "./RadioImage.vue?vue&type=style&index=0&id=11a2a7c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a2a7c3",
  null
  
)

export default component.exports